module.exports = __webpack_public_path__ + "img/andrin_portrait_ocular.374ce660.jpg";